import React, { forwardRef } from "react";
import "../../styles/ComponentsStyles/Universal/ToggleBtn.style.css";
const NormalToggleInputField = forwardRef(
  (
    { type, label = "", value, setFieldValue, name, checked, isRequired },
    ref
  ) => {
    const changeButtonStatus = (e) => {
      const isChecked = e.target.checked;
      setFieldValue(name, isChecked ? value : "");
    };

    return (
      <div className="toggleBtn">
        <label htmlFor={label}>{label}</label>
        <input
          ref={ref}
          type={type}
          checked={checked}
          name={name}
          value={value}
          onChange={changeButtonStatus}
          required={isRequired}
        />
      </div>
    );
  }
);
export default NormalToggleInputField;
